export default __webpack_public_path__ + "static/media/menu-seeks-white.23a07b62.svg";